// extracted by mini-css-extract-plugin
module.exports = {"item":"Tasks_item_3fTT2","headerText":"Tasks_headerText_14TFh","container":"Tasks_container_2R9A4","img":"Tasks_img_2dqni","containerCount":"Tasks_containerCount_3TPWf"};